<ol class="breadcrumb float-sm-right">
  <li class="breadcrumb-item" *ngFor="let item of items">
    <a [routerLink]="item.route">{{ item.text }}</a>
  </li>
  <li *ngIf="last != null" class="breadcrumb-item active">{{ last.text }}</li>
</ol>
